import React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import { LazyLoadComponent } from "react-lazy-load-image-component"
import Swiper from "react-id-swiper"
import "swiper/css/swiper.css"
import { Navigation, Pagination } from "swiper/js/swiper.esm"
import useMediaQuery from "../hooks/useMediaQuery"
import marked from "marked"

const AIDriven = () => {
  const isDesktop = useMediaQuery("(min-width: 768px)")
  const params = {
    modules: [Pagination, Navigation],
    slidesPerView: 1,
    spaceBetween: 30,
    breakpoints: {
      280: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
    },
    containerClass: "swiper-container pb-5",
    nested: true,

    autoplay: false,
    // {
    //   delay: 5000,
    //   disableOnInteraction: false,
    // },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  }

  const data = [
    {
      title: "Low-Code Custom Application Developement",
      description:
        "<p>Get your team out of the spreadsheets and in front of customers with low-code applications that streamline operations, improve customer service, and provide clean data for AI-driven insights.</p>",
      url: "/custom-quickbase-application-development/",
      imgUrl: "/dceec435af07d66ca7a1aa259a5bdfc91ea427ff-1280x960.jpg",
      direction: "ltr",
    },
    {
      title: "Integrate and Automate Workflows",
      description:
        "<p>Eliminate manual data entry by connecting your disparate systems. Accelerate your ROI with reduced labor costs, fewer mistakes, and real-time data insights.</p>",
      url: "/quickbase-integration-services/",
      imgUrl: "/d59e61ab873e78f8a1ee6e84ea00ce619c06e0c2-1280x959.jpg?w=570",
      direction: "rtl",
    },
  ]

  return (
    <section
      id="it-consulting"
      className="it-consulting"
      style={{ padding: "24px 0" }}
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-8 mx-auto text-center">
            <h2 className="my-3 font-weight-medium">
              Why Keep Up with Competitors When You Can Wave at Them From The
              Finish Line?
            </h2>
            <p
              className="text-center mx-auto px-sm-2"
              style={{ maxWidth: "825px" }}
            >
              Redefine your industry by rapidly reimagining workflows and
              launching AI-driven services that surpass what both your customers
              (and the competition) thought possible.
            </p>
          </div>
        </div>
        {isDesktop ? (
          <LazyLoadComponent>
            <div class="tabs pt-4">
              <input
                type="radio"
                class="tabs__radio"
                name="tabs-example"
                id="tab1"
                defaultChecked
              />
              <label
                for="tab1"
                class="tabs__label mx-auto text-center"
                style={{ width: "30%" }}
              >
                Increased Efficiency
              </label>
              <div class="tabs__content">
                <div
                  className="row align-items-center mt-3 mb-5"
                  style={{ boxShadow: "rgba(0, 0, 0, 0.16) 0px 3px 100px" }}
                >
                  <div className="col-lg-6 col-md-6 mt-4 mb-4">
                    <StaticImage
                      placeholder="blurred"
                      className="rounded d-flex w-100"
                      src="https://cdn.sanity.io/images/55lcecww/production/276fffb2e7fc6d2995eb18374bbb592e5264161c-1920x1281.jpg"
                      alt="Increased Efficiency"
                      layout="constrained"
                      style={{ height: "20rem" }}
                      fetchpriority="low"
                    />
                  </div>
                  <div className="col-lg-6 col-md-6 text-lg-left text-md-left text-center align-self-center mb-lg-0 mb-md-0 mb-5 pl-md-5">
                    <h3 className="text-left-mobile">Increased Efficiency</h3>
                    <p className="my-4 text-left-mobile">
                      Focus more on strategic (and exciting) work by automating
                      repetitive tasks. With AI reducing errors and tedious
                      tasks, your team can innovate where it matters most.
                    </p>
                    {/* <Link
                      className="btn btn-primary btn-arrow"
                      to="/citizen-development-support/
              "
                    >
                      Find Your AI Gaps
                    </Link> */}
                  </div>
                </div>
              </div>
              <input
                type="radio"
                class="tabs__radio"
                name="tabs-example"
                id="tab2"
              />
              <label
                for="tab2"
                class="tabs__label mx-auto text-center"
                style={{ width: "30%" }}
              >
                Data-Driven Decisions
              </label>
              <div class="tabs__content">
                <div
                  className="row align-items-center flex-column-reverse flex-lg-row flex-md-row mt-3 mb-5"
                  style={{ boxShadow: "rgba(0, 0, 0, 0.16) 0px 3px 100px" }}
                >
                  <div className="col-lg-6 col-md-6 text-lg-left text-md-left mt-lg-0 mt-md-0 mt-5 text-center mb-lg-0 mb-md-0 mb-5 pl-md-5">
                    <h3 className="text-left-mobile">Data-Driven Decisions</h3>
                    <p className="my-4 text-left-mobile">
                      Make more informed decisions faster with AI-powered
                      predictive analytics. Uncover hidden trends and patterns
                      in your data, staying two steps ahead in unpredictable
                      markets.
                    </p>
                    {/* <Link
                      className="btn btn-primary btn-arrow"
                      to="/software-asset-management/"
                    >
                      Audit Your Tech Stack
                      <span className="d-none">
                        This is a redirection to quandary-connect
                      </span>
                    </Link> */}
                  </div>
                  <div className="col-lg-6 col-md-6 my-lg-4 my-md-4 my-0 mt-lg-0 mt-md-0 mt-5">
                    <StaticImage
                      placeholder="blurred"
                      className="rounded d-flex w-100"
                      src="https://cdn.sanity.io/images/55lcecww/production/22a43ec4a9d74b0f72d071705cf879f4ee59fbeb-1920x1382.jpg"
                      alt="Data-Driven Decisions"
                      layout="constrained"
                      style={{ height: "20rem" }}
                      fetchpriority="low"
                    />
                  </div>
                </div>
              </div>
              <input
                type="radio"
                class="tabs__radio"
                name="tabs-example"
                id="tab3"
              />
              <label
                for="tab3"
                class="tabs__label mx-auto text-center"
                style={{
                  width: "30%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                Cost Savings
              </label>
              <div class="tabs__content">
                <div
                  className="row align-items-center mt-3 mb-5"
                  style={{ boxShadow: "rgba(0, 0, 0, 0.16) 0px 3px 100px" }}
                >
                  <div className="col-lg-6 col-md-6 mt-4 mb-4">
                    <StaticImage
                      placeholder="blurred"
                      className="rounded d-flex w-100"
                      src="https://cdn.sanity.io/images/55lcecww/production/73858682625b7d300f05c11c3907a1d2ab04556e-1920x1281.jpg"
                      alt=" Cost Savings"
                      layout="constrained"
                      style={{ height: "20rem" }}
                      fetchpriority="low"
                    />
                  </div>
                  <div className="col-lg-6 col-md-6 text-lg-left text-md-left text-center align-self-center mb-lg-0 mb-md-0 mb-5 pl-md-5">
                    <h3 className="text-left-mobile">Cost Savings</h3>
                    <p className="my-4 text-left-mobile">
                      Use AI to reduce waste, optimize resources, and accomplish
                      more with less. Identify inefficiencies in real-time and
                      invest your budget where it matters most.
                    </p>
                    {/* <Link
                      className="btn btn-primary btn-arrow"
                      to="/citizen-development-support/
              "
                    >
                      Find Your AI Gaps
                    </Link> */}
                  </div>
                </div>
              </div>
              <input
                type="radio"
                class="tabs__radio"
                name="tabs-example"
                id="tab4"
              />
              <label
                for="tab4"
                class="tabs__label mr-3 ml-auto mt-2 text-center"
                style={{ width: "30%" }}
              >
                Competitive Advantage
              </label>
              <div class="tabs__content">
                <div
                  className="row align-items-center flex-column-reverse flex-lg-row flex-md-row mt-3 mb-5"
                  style={{ boxShadow: "rgba(0, 0, 0, 0.16) 0px 3px 100px" }}
                >
                  <div className="col-lg-6 col-md-6 text-lg-left text-md-left mt-lg-0 mt-md-0 mt-5 text-center pl-md-5">
                    <h3 className="text-left-mobile">Competitive Advantage</h3>
                    <p className="my-4 text-left-mobile">
                      Outpace competitors and adapt faster by knowing where to
                      innovate and how. Instead of developing solutions to keep
                      up with everyone else, you set the industry standard.
                    </p>
                    {/* <Link
                      className="btn btn-primary btn-arrow mb-lg-0 mb-md-4 mb-5"
                      to="/quickbase-application-development/"
                    >
                      How We Build
                    </Link> */}
                  </div>
                  <div className="col-lg-6 col-md-6 mt-lg-4 mb-lg-4">
                    <StaticImage
                      placeholder="blurred"
                      className="rounded d-flex"
                      src="https://cdn.sanity.io/images/55lcecww/production/6e7d58757ebdb738caf5909317ac02d12e1b5ab8-1920x1280.jpg"
                      alt="Competitive Advantage"
                      layout="constrained"
                      style={{ height: "20rem" }}
                      fetchpriority="low"
                    />
                  </div>
                </div>
              </div>
              <input
                type="radio"
                class="tabs__radio"
                name="tabs-example"
                id="tab5"
              />
              <label
                for="tab5"
                class="tabs__label ml-3 mr-auto text-center mt-2"
                style={{
                  width: "30%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                More Scalability
              </label>
              <div class="tabs__content">
                <div
                  className="row align-items-center mt-3 mb-5"
                  style={{ boxShadow: "rgba(0, 0, 0, 0.16) 0px 3px 100px" }}
                >
                  <div className="col-lg-6 col-md-6 mt-4 mb-4">
                    <StaticImage
                      placeholder="blurred"
                      className="rounded d-flex w-100"
                      src="https://cdn.sanity.io/images/55lcecww/production/732d13c7f70d1541ea65bd8b283566b00ee58a5a-1920x1280.jpg"
                      alt=" More Scalability"
                      layout="constrained"
                      style={{ height: "20rem" }}
                      fetchpriority="low"
                    />
                  </div>
                  <div className="col-lg-6 col-md-6 text-lg-left text-md-left text-center align-self-center mb-lg-0 mb-md-0 mb-5 pl-md-5">
                    <h3 className="text-left-mobile">More Scalability</h3>
                    <p className="my-4 text-left-mobile">
                      Expand confidently with AI-driven systems that adapt to
                      overnight shifts in market conditions and customer needs.
                      Embrace new opportunities without compromise.
                    </p>
                    {/* <Link
                      className="btn btn-primary btn-arrow"
                      to="/citizen-development-support/
              "
                    >
                      Find Your AI Gaps
                    </Link> */}
                  </div>
                </div>
              </div>
            </div>

            {/* 
            <div className="row align-items-center">
              <div className="col-lg-6 col-md-6 mt-4 mb-4">
                <StaticImage
                  placeholder="blurred"
                  className="rounded d-flex w-100"
                  src="https://cdn.sanity.io/images/55lcecww/production/e90ceb8caee9906854df62ee9bcf372a7e9e56ad-1280x788.jpg?w=570"
                  alt="Application Development"
                  layout="constrained"
                  style={{ height: "20rem" }}
                  
                  fetchpriority="low"
                />
              </div>
              <div className="col-lg-6 col-md-6 text-lg-left text-md-left text-center align-self-center mb-lg-0 mb-md-0 mb-5 pl-md-5">
                <h3 className="text-left-mobile">
                  End-to-End Procurement Optimization
                </h3>
                <p className="my-4 text-left-mobile">
                  Looking to streamline invoicing? Want to manage your vendors
                  from one, simple platform? Eager to supercharge your entire
                  procurement process with automation? We transform your supply
                  chain into a strategic asset.
                </p>
                <Link
                  className="btn btn-primary btn-arrow"
                  to="/procurement-automation-services/"
                >
                  Explore Procurement Automation
                  <span className="d-none">
                    This is a redirection to Procurement Automation
                  </span>
                </Link>
              </div>
            </div> */}

            {/* <div
              className="row align-items-center flex-column-reverse flex-lg-row flex-md-row"
              style={{ boxShadow: "rgba(0, 0, 0, 0.16) 0px 3px 100px" }}
            >
              <div className="col-lg-6 col-md-6 text-lg-left text-md-left mt-lg-0 mt-md-0 mt-5 text-center mb-lg-0 mb-md-0 mb-5 pl-md-5">
                <h3 className="text-left-mobile">
                  Offline Construction Management
                </h3>
                <p className="my-4 text-left-mobile">
                  Get custom construction management solutions that work
                  offline, so you can effortlessly manage your workforce. No
                  matter the job site. Don’t let WiFi access restrict your team.
                </p>
                <Link
                  className="btn btn-primary btn-arrow"
                  to="/offline-application-development-construction-management/"
                >
                  Explore Construction Management
                </Link>
              </div>
              <div className="col-lg-6 col-md-6 my-lg-4 my-md-4 my-0 mt-lg-0 mt-md-0 mt-5">
                <StaticImage
                  placeholder="blurred"
                  className="rounded d-flex w-100"
                  src="https://cdn.sanity.io/images/55lcecww/production/574c4615dd06ab10e6cb8d2bd0c9dea134d8a37e-2000x1333.jpg"
                  alt="Construction Management"
                  layout="constrained"
                  style={{ height: "20rem" }}
                  
                  fetchpriority="low"
                />
              </div>
            </div> */}
          </LazyLoadComponent>
        ) : (
          <div className="mobile-swiper d-flex flex-column">
            <LazyLoadComponent>
              <div className="pt-md-5 pb-md-5">
                <div>
                  <div className="col-12 text-center">
                    <h3 className="">Increased Efficiency</h3>
                    <p className="my-4 ">
                      Focus more on strategic (and exciting) work by automating
                      repetitive tasks. With AI reducing errors and tedious
                      tasks, your team can innovate where it matters most.
                    </p>

                    {/* <Link
                      className="btn btn-primary btn-arrow"
                      to="/technology-consulting/"
                    >
                      Start Your Analysis
                      <span className="d-none">
                        This is a redirection to quandary-build
                      </span>
                    </Link> */}
                  </div>
                  <div className="col-12">
                    {/* <StaticImage
                        placeholder="blurred"
                        className="rounded d-flex w-100"
                        src="https://cdn.sanity.io/images/55lcecww/production/6a384fbfcf147dea7e9056c75dae53153353f6e3-1280x960.jpg?w=570"
                        alt="Application Development"
                        layout="constrained"
                        
                        fetchpriority="low"
                      /> */}
                    <img
                      placeholder="blurred"
                      className="rounded d-flex w-100 tabs-img-responsive img-fluid"
                      src="https://cdn.sanity.io/images/55lcecww/production/276fffb2e7fc6d2995eb18374bbb592e5264161c-1920x1281.jpg"
                      alt="Increased Efficiency"
                      layout="constrained"
                      fetchpriority="low"
                    />
                  </div>
                </div>
              </div>
              <div className="pt-md-5 pb-md-5">
                <div>
                  <div className="col-12 text-center">
                    <h3 className="">Data-Driven Decisions</h3>
                    <p className="my-4 ">
                      Make more informed decisions faster with AI-powered
                      predictive analytics. Uncover hidden trends and patterns
                      in your data, staying two steps ahead in unpredictable
                      markets.
                    </p>
                    {/* <Link
                      className="btn btn-primary btn-arrow"
                      to="/software-asset-management/"
                    >
                      Audit Your Tech Stack
                      <span className="d-none">
                        This is a redirection to quandary-connect
                      </span>
                    </Link> */}
                  </div>
                  <div className="col-12">
                    <StaticImage
                      placeholder="blurred"
                      className="rounded d-flex w-100 tabs-img-responsive"
                      src="https://cdn.sanity.io/images/55lcecww/production/22a43ec4a9d74b0f72d071705cf879f4ee59fbeb-1920x1382.jpg"
                      alt="Data-Driven Decisions"
                      layout="constrained"
                      style={{ height: "20rem" }}
                      fetchpriority="low"
                    />
                  </div>
                </div>
              </div>
              <div className="pt-md-5 pb-md-5">
                <div>
                  <div className="col-12 text-center">
                    <h3 className="">Cost Savings</h3>
                    <p className="my-4 ">
                      Use AI to reduce waste, optimize resources, and accomplish
                      more with less. Identify inefficiencies in real-time and
                      invest your budget where it matters most.
                    </p>
                    {/* <Link
                      className="btn btn-primary btn-arrow"
                      to="/citizen-development-support/"
                    >
                      Find Your AI Gaps
                      <span className="d-none">
                        This is a redirection to Procurement Automation
                      </span>
                    </Link> */}
                  </div>
                  <div className="col-12">
                    <img
                      placeholder="blurred"
                      className="rounded d-flex w-100 tabs-img-responsive"
                      src="https://cdn.sanity.io/images/55lcecww/production/73858682625b7d300f05c11c3907a1d2ab04556e-1920x1281.jpg"
                      alt="Cost Savings"
                      layout="constrained"
                      fetchpriority="low"
                    />
                  </div>
                </div>
              </div>
              <div className="pt-md-5 pb-md-5">
                <div>
                  <div className="col-12 text-center">
                    <h3 className="">Competitive Advantage</h3>
                    <p className="my-4 ">
                      Outpace competitors and adapt faster by knowing where to
                      innovate and how. Instead of developing solutions to keep
                      up with everyone else, you set the industry standard.
                    </p>
                    {/* <Link
                      className="btn btn-primary btn-arrow"
                      to="/quickbase-application-development/"
                    >
                      How We Build
                    </Link> */}
                  </div>
                  <div className="col-12">
                    <StaticImage
                      placeholder="blurred"
                      className="rounded d-flex w-100 tabs-img-responsive"
                      src="https://cdn.sanity.io/images/55lcecww/production/6e7d58757ebdb738caf5909317ac02d12e1b5ab8-1920x1280.jpg"
                      alt="Competitive Advantage"
                      layout="constrained"
                      style={{ height: "20rem" }}
                      fetchpriority="low"
                    />
                  </div>
                </div>
              </div>
              <div className="pt-md-5 pb-md-5">
                <div>
                  <div className="col-12 text-center">
                    <h3 className="">More Scalability</h3>
                    <p className="my-4 ">
                      Expand confidently with AI-driven systems that adapt to
                      overnight shifts in market conditions and customer needs.
                      Embrace new opportunities without compromise.
                    </p>
                    {/* <Link
                      className="btn btn-primary btn-arrow"
                      to="/quickbase-application-development/"
                    >
                      How We Build
                    </Link> */}
                  </div>
                  <div className="col-12">
                    <StaticImage
                      placeholder="blurred"
                      className="rounded d-flex w-100 tabs-img-responsive"
                      src="https://cdn.sanity.io/images/55lcecww/production/732d13c7f70d1541ea65bd8b283566b00ee58a5a-1920x1280.jpg"
                      alt="More Scalability"
                      layout="constrained"
                      style={{ height: "20rem" }}
                      fetchpriority="low"
                    />
                  </div>
                </div>
              </div>
              {/* <div className="swiper-slide">
                  <div>
                    <div className="col-12">
                      <img
                        placeholder="blurred"
                        className="rounded d-flex w-100 tabs-img-responsive"
                        src="https://cdn.sanity.io/images/55lcecww/production/a05d3486dd392b13a8c69d078aeb51fdd1b257c6-2000x1334.jpg"
                        alt="Citizen Development"
                        layout="constrained"
                        
                        fetchpriority="low"
                      />
                    </div>
                    <div className="col-12 text-center">
                      <h3 className="text-left-mobile">
                        Citizen Development Governance
                      </h3>
                      <p className="my-4 text-left-mobile">
                        We help organizations stand up and govern citizen
                        development programs encouraging safe, scalable
                        innovation. Accomplish more. Risk less.
                      </p>
                      <Link
                        className="btn btn-primary btn-arrow"
                        to="/citizen-development-support/
              "
                      >
                        Explore Citizen Development Governance
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="swiper-slide">
                  <div>
                    <div className="col-12">
                      <StaticImage
                        placeholder="blurred"
                        className="rounded d-flex"
                        src="https://cdn.sanity.io/images/55lcecww/production/d9df676a86e906bcc9f49e85cb19a6ecd89aa386-810x608.jpg"
                        alt="Solution Provider"
                        layout="constrained"
                        style={{ height: "20rem" }}
                        
                        fetchpriority="low"
                      />
                    </div>
                    <div className="col-12 text-center">
                      <h3 className="text-left-mobile">
                        Business Process Improvement
                      </h3>
                      <p className="my-4 text-left-mobile">
                        Fix broken systems and remove the manual processes to
                        increase your team's productivity and eliminate
                        unnecessary slowdowns and bottlenecks with automated
                        workflows.
                      </p>
                      <Link
                        className="btn btn-primary btn-arrow mb-lg-0 mb-md-4 mb-5"
                        to="/tech-consulting/"
                      >
                        Explore Business Process Improvement
                      </Link>
                    </div>
                  </div>
                </div> */}
            </LazyLoadComponent>
          </div>
        )}
      </div>
    </section>
  )
}

export default AIDriven
